import axios from 'axios';

class Hammauth {
	validateToken = data => {
		return new Promise((resolve, reject) => {
			axios
				.request({
					headers: {
						'X-Hammurabi-Key': `${process.env.REACT_APP_HAMMURABI_KEY}`,
					},
					method: 'POST',
					url: `${process.env.REACT_APP_HAMMURABI_API}/auth/validate`,
					data: data,
				})
				.then(({ data }) => {
					resolve(data);
				})
				.catch(e => {
					reject(e);
				});
		});
	};
}

const instance = new Hammauth();

export default instance;
